import * as login from './moudules/login'
import * as home from './moudules/home'
import * as list from './moudules/list'
import * as user from './moudules/user'
import * as detail from './moudules/detail'
export default {
    login,
    home,
    list,
    user,
    detail
}